require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./business-continuity-plan.json") })
        }
      }, "path---business-continuity-plan");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---business-continuity-plan!./.cache/json/business-continuity-plan.json
// module id = 443
// module chunks = 231608221292675